import { useCallback } from "react";
import { useNavigate as useRouterNavigate } from "react-router-dom";
import { requestLeave } from "@/lib/leaveRegistry";

/** iter446 — POINT D'ENTRÉE COMMUN de la navigation programmatique : tout `navigate()` consulte le registre des modifications non enregistrées
 *  et affiche DeskLeaveDialog si nécessaire. `useNavigate` de react-router-dom est interdit ailleurs (garde check-navigation). */
export function useNavigate() {
  const raw = useRouterNavigate();
  return useCallback((to, opts) => requestLeave("page", () => raw(to, opts)), [raw]);
}
export default useNavigate;

/** Changement d'onglet (Tabs onValueChange, barres d'onglets maison) : `onValueChange={guardTab(setTab)}`. */
export const guardTab = (fn) => (v, ...rest) => requestLeave("page", () => fn(v, ...rest));
